import Vue from "vue";
import router from "vue-router";

Vue.use(router);

export default new router({
  mode:'history',
  routes: [
    {
      path: "/",
      redirect: "/",
      component: () => import("@/view/layout/Layout"),
      children: [
        {
          path: "/",
          name: "Procedures",
          component: () => import("@/view/pages/Signing/SigningProcedures.vue"),
          meta: {
            journey: 1,
            title: "Bağlantı Kontrolü",
            subtitle: "İşlemlere başlayabilmek için bilgisayarınızdaki Nilvera Web Soket uygulaması ile bağlantı kuruluyor."
          }
        },
        {
          path: "/login",
          name: "login",
          component: () => import("@/view/pages/Signing/Login.vue"),
          meta: {
            journey: 2,
            title: "Akıllı Kart ile Giriş",
            subtitle: "e-İmza veya Mali Mühürünüz ile güvenli bir şekilde giriş yapın."
          }
        },
        {
          path: "/create",
          name: "create",
          component: () => import("@/view/pages/Signing/Create.vue"),
          meta: {
            journey: 3,
            title: "Başvuru İşlemleri",
            subtitle: "Adımları sırasıyla takip ederek başvurunuzu kolayca tamamlayabilirsiniz."
          }
        },
        {
          path: "/dashboard",
          name: "dashboard",
          component: () => import("@/view/pages/Signing/Dashboard.vue"),
          meta: {
            journey: 3,
            title: "Firma Bilgileri",
            subtitle: "Firmalarınızı, modüllerinizi ve aktivasyon süreçlerinizi tek ekrandan yönetin."
          }
        }
      ]
    },
    {
      path: "*",
      redirect: "/404"
    },
    {
      // the 404 route, when none of the above matches
      path: "/404",
      name: "404",
      component: () => import("@/view/pages/error/404.vue")
    }
  ]
});
